import { render, staticRenderFns } from "./WarehouseInfo.vue?vue&type=template&id=72806797&scoped=true"
import script from "./WarehouseInfo.vue?vue&type=script&lang=js"
export * from "./WarehouseInfo.vue?vue&type=script&lang=js"
import style0 from "./WarehouseInfo.vue?vue&type=style&index=0&id=72806797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72806797",
  null
  
)

export default component.exports